<template>
  <v-container fluid>
    <main-header-plat-a-pat />
    <main-header-plat-b :navBItems="schema.navBItems" />
    <v-overlay-loader />
    <v-row class="d-flex justify-center mx-auto" style="width: 95%">
      <v-card style="width: 80%" flat>
        <v-card-subtitle class="text-subtitle-1 font-weight-medium pb-0 mb-1 mt-8">
          Datos de Filiación
        </v-card-subtitle>
        <v-card-text class="pb-0" style="min-height: 380px">
          <v-form-base
            v-if="
              Object.keys(schema.schemaForm || {}).length && Object.keys(modelForm || {}).length
            "
            :schema="schema.schemaForm"
            :model="modelForm"
            @input="handleEvents"
          />
        </v-card-text>
        <v-banner-action-form
          :save="save"
          :nextPage="schema.nextPage"
          :dialogAccountPin="schema.dialogAccountPin"
        />
        <v-snack-bar :snackbar="snackbar" />
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatAPat from '@/components/includes/MainHeaderPlatAPat.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VOverlayLoader from '@/components/base/VOverlayLoader.vue';
import VFormBase from 'vuetify-form-base';
import VBannerActionForm from '@/components/base/VBannerActionForm.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'patProfileAPage',
  components: {
    MainHeaderPlatAPat,
    MainHeaderPlatB,
    VOverlayLoader,
    VFormBase,
    VBannerActionForm,
    VSnackBar,
  },
  data() {
    return {};
  },
  mounted() {
    this.loadSchema();
    this.loadCatDepartments();
    this.loadModelForm();
  },
  computed: {
    ...mapGetters('patProfileAPage', [
      'schema',
      'catDepartments',
      'modelForm',
      'status',
    ]),
    ...mapGetters('notifications', ['snackbar']),
  },
  methods: {
    ...mapActions('patProfileAPage', [
      'loadSchema',
      'loadCatDepartments',
      'loadModelForm',
    ]),
    ...mapActions('notifications', ['triggerSnackbar']),

    handleEvents(val) {
      this.val = val;
      this.ubigeo();
    },
    ubigeo() {
      const usersCountry = this.val.data.users_birth_iso3366;

      if (!usersCountry) return;

      if (usersCountry === 'PE') {
        this.schema.schemaForm.group2.schema.users_birth_department.items = this.catDepartments;
      } else if (usersCountry !== 'PE') {
        this.schema.schemaForm.group2.schema.users_birth_department.items = [
          { departments_id: '999999', departments: '---' },
        ];
        this.modelForm.group2.users_birth_department = '999999';
      }
    },
    async save() {
      const { group2 } = this.modelForm;
      const model = group2;
      model.users_birth_ubigeo = model.users_birth_district;

      this.$store.dispatch('patProfileAPage/save', model).then(
        () => {
          this.reload();
          this.snackbarOpen();
        },
        () => {
          this.reload();
          this.snackbarOpen();
        }
      );
    },
    reload() {
      this.loadModelForm();
    },
    snackbarOpen() {
      this.snackbar.visible = false;
      if (this.status === 'success') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackOk;
      } else if (this.status === 'error') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackError;
      }
    },
  },
};
</script>
